module.exports = __webpack_public_path__ + "img/NTI-logo.aa4f0172.png";